
const FlexTimeline = require('../viscomjs/flexTimeline/FlexTimeline');
const PIXI = require('pixi.js');
const settings = require('../settings.json');

const _constructScenesLayers = app => {
    const cover = new PIXI.Container();
    const intro1 = new PIXI.Container();
    const pictures = new PIXI.Container();
    const palestinians = new PIXI.Container();
    const transitions = new PIXI.Container();
    const smoke = new PIXI.Container();
    const finalSeq = new PIXI.Container();

    cover.name = 'cover';
    app.stage.cover = cover;

    intro1.name = 'intro1';
    app.stage.intro1 = intro1;

    pictures.name = 'pictures';
    app.stage.pictures = pictures;

    palestinians.name = 'palestinians';
    app.stage.palestinians = palestinians;

    transitions.name = 'transitions';
    app.stage.transitions = transitions;

    smoke.name = 'smoke';
    app.stage.smoke = smoke;

    smoke.name = 'finalSeq';
    app.stage.finalSeq = finalSeq;

    app.stage.addChild(cover);
    app.stage.addChild(intro1);
    app.stage.addChild(pictures);
    app.stage.addChild(transitions);
    app.stage.addChild(palestinians);
    app.stage.addChild(smoke);
    app.stage.addChild(finalSeq);
}

const initTimeline = app => {

    _constructScenesLayers(app);

    const flex = new FlexTimeline();
    const DoublePictureWithOverlay = require('./timelines/illustrations/DoublePictureWithOverlay');
    const DuoText = require('./timelines/texts/DuoText');
    const OpacityText = require('./timelines/texts/OpacityText');


    /* SAMPLE:
    1) Inline

     flex.add({{time to start}}, {{total Particular Timeline duration}}, () => {

        {{Construct assets}}
        {{Add all or some listeners}}

        return {{Particular Timeline}};

    }, () => {

        {{Kill Particular Timeline}}
        {{Remove all the listeners}}
        {{Destroy assets}}

     },
     {{Optional: time-delta before and after timeline to store assets and timeline before destruction}});

     2) Stand Alone JS-file

     let Timeline = require({{ Path to a bunch of cunstructor / destructor }});
     let timeline = Timeline(app, {{ Any customization parameters }});
     flex.add({{ time to start }}, {{ total Particular Timeline duration }}, timeline.create, timeline.destroy, {{ Optional: time-delta before and after timeline to store assets and timeline before destruction }});
     */

    flex.cuePoints = [];
    let T = 0;
    let D = 0;

    // Slide 0 - Cover
    let Timeline = require('./timelines/illustrations/CoverTimelineConstructor');
    let timeline = Timeline(app, app.stage.cover);
    flex.add(0, timeline.totalDuration, timeline.create, timeline.destroy);
    T += timeline.startDuration;
    D = timeline.totalDuration;

    let TextTimeline = require('./timelines/texts/TitleText');
    let textTimeline = TextTimeline(D);
    flex.add(0, textTimeline.totalDuration, textTimeline.create, textTimeline.destroy);

    flex.cuePoints.push(T);

    // Slide 0 - Fog
    Timeline = require('./timelines/illustrations/FogTimelineConstructor');
    timeline = Timeline(app, app.stage.smoke);
    flex.add(0, timeline.totalDuration, timeline.create, timeline.destroy);

    // Slide 1 - Solder
    Timeline = require('./timelines/illustrations/IntroPart1_Solder');
    timeline = Timeline(app, app.stage.intro1);
    flex.add(T, timeline.totalDuration, timeline.create, timeline.destroy);
    D = timeline.refDuration * 1.1;

    TextTimeline = require('./timelines/texts/InroText');
    textTimeline = TextTimeline(D, true);
    flex.add(T - D * 0.23, textTimeline.totalDuration, textTimeline.create, textTimeline.destroy);

    T += timeline.refDuration * 0.8;

    // VIDEO
    Timeline = require('./timelines/transitions/DOMFadeTransition');
    timeline = Timeline('.video__fade .fade', {
        inDuration: D * 0.21,
        idleDuration: 0,
        outDuration: 1
    });
    flex.add(T - timeline.startDuration, timeline.totalDuration, timeline.create, timeline.destroy);

    T -= D * 0.1;

    Timeline = require('./timelines/VideoTimeline');
    timeline = Timeline('.video', settings.videoYTID, 2.5);
    flex.add(T - timeline.startDuration, timeline.totalDuration, timeline.create, timeline.destroy);

    T += timeline.totalDuration - timeline.startDuration;


    Timeline = require('./timelines/transitions/DOMFadeTransition');
    timeline = Timeline('.video__fadeIn .fade', {
        inDuration: 1,
        idleDuration: 2,
        outDuration: 0.01
    });
    flex.add(T - timeline.startDuration, timeline.totalDuration, timeline.create, timeline.destroy);

    TextTimeline = require('./timelines/texts/IntroTextP2');
    textTimeline = TextTimeline(4);
    flex.add(T - textTimeline.startDuration, textTimeline.totalDuration, textTimeline.create, textTimeline.destroy);

    T += timeline.totalDuration - timeline.startDuration;

    // Slide 2 - Apotheosis
    Timeline = require('./timelines/transitions/FlockTransition');
    timeline = Timeline(app, app.stage.transitions);
    flex.add(T - timeline.startDuration, timeline.totalDuration, timeline.create, timeline.destroy);

    const addCustomTimeline = require('./timelines/illustrations/AddApotheosisCustomTimeline');
    timeline = DoublePictureWithOverlay(app, app.stage.pictures, {
        picture1: 'apotheosis',
        picture2: null,
        idleDuration: 2,
        transitionDuration: 1,
        fadeDuration: 4.5,
        addCustomTimeline: addCustomTimeline
    });
    flex.add(T, timeline.totalDuration, timeline.create, timeline.destroy);

    TextTimeline = require('./timelines/texts/IntroTextP3');
    textTimeline = TextTimeline(timeline.totalDuration - timeline.startDuration);
    flex.add(T + timeline.startDuration - textTimeline.startDuration, textTimeline.totalDuration, textTimeline.create, textTimeline.destroy);

    T += timeline.totalDuration;

    // Slide 3 - Before Attack
    Timeline = require('./timelines/transitions/RavenTransition');
    timeline = Timeline(app, app.stage.transitions);
    flex.add(T - timeline.startDuration, timeline.totalDuration, timeline.create, timeline.destroy);
    D = timeline.totalDuration - timeline.startDuration;

    Timeline = require('./timelines/illustrations/BattleSmokeTimeline');
    timeline = Timeline(app, app.stage.smoke, 5);
    flex.add(T - timeline.startDuration, timeline.totalDuration, timeline.create, timeline.destroy);

    timeline = DoublePictureWithOverlay(app, app.stage.pictures, {
        picture1: 'beforeAttack',
        picture2: 'beforeAttackAlternative',
        idleDuration: -timeline.startDuration + timeline.totalDuration * 0.7,
        transitionDuration: 1,
        fadeDuration: 4 + 1,
        enabledDuration: 1.2,
        overlayOpacity: 0.83,
        overlayOpacity2: 0.6
    });
    flex.add(T, timeline.totalDuration, timeline.create, timeline.destroy);
    flex.cuePoints.push(T + timeline.startDuration);

    textTimeline = DuoText('[data-text-unit="duo1"]', timeline.totalDuration - timeline.startDuration - 1);
    flex.add(T + timeline.startDuration - textTimeline.startDuration, textTimeline.totalDuration, textTimeline.create, textTimeline.destroy);

    T += timeline.totalDuration;

    // Slide 4 - Tadj-Mahal
    Timeline = require('./timelines/transitions/MountainsTransition');
    timeline = Timeline(app, app.stage.transitions);
    T -= timeline.startDuration;
    T -= timeline.transitionDuration;
    flex.add(T, timeline.totalDuration, timeline.create, timeline.destroy);
    D = timeline.transitionDuration;
    const D1 = timeline.startDuration;

    const AddBWImageTimelineAtStart = require('./timelines/illustrations/AddBWImageTimelineAtStart');
    const AddWipeTimelineAtStart = require('./timelines/illustrations/AddWipeTimelineAtStart');
    timeline = DoublePictureWithOverlay(app, app.stage.pictures, {
        picture1: 'tajMahal_2',
        picture2: 'tajMahal_2_Alternative',
        idleDuration: 3.5,
        transitionDuration: 1,
        fadeDuration: 4.5,
        enabledDuration: 1.5,
        overAll: true,
        addCustomTimeline: function (tl, instance, setLabel, inLabel, outLabel, offLabel) {
            AddBWImageTimelineAtStart(tl, instance.pic1, D1 + D / 1.8, D, setLabel, inLabel, outLabel, offLabel);
            AddWipeTimelineAtStart(tl, instance.cont, instance.picCont, D1, D, setLabel, inLabel, outLabel, offLabel);
        }
    });
    flex.add(T, timeline.totalDuration, timeline.create, timeline.destroy);
    flex.cuePoints.push(T + timeline.startDuration);

    textTimeline = DuoText('[data-text-unit="duo2"]', timeline.totalDuration - timeline.startDuration - 1);
    flex.add(T + timeline.startDuration - textTimeline.startDuration - 0.1, textTimeline.totalDuration, textTimeline.create, textTimeline.destroy);

    T += timeline.totalDuration;

    // Slide 5 - Palestinian
    Timeline = require('./timelines/transitions/FadeTransition');
    timeline = Timeline(app, app.stage.transitions);
    flex.add(T - timeline.startDuration, timeline.totalDuration, timeline.create, timeline.destroy);
    T -= timeline.startDuration;

    Timeline = require('./timelines/illustrations/PalestiniansTimeline');
    timeline = Timeline(app, app.stage.palestinians, {
        picture2: 'palestinians_Alternative',
        idleDuration: 2,
        transitionDuration: 1,
        fadeDuration: 8,
        enabledDuration: 1.8,
        overlayOpacity2: 0.67
    });
    flex.add(T, timeline.totalDuration, timeline.create, timeline.destroy);
    flex.cuePoints.push(T + timeline.startDuration);

    textTimeline = DuoText('[data-text-unit="duo3"]', timeline.totalDuration - timeline.startDuration - 5 * 8 / 9);
    flex.add(T + timeline.startDuration - textTimeline.startDuration, textTimeline.totalDuration, textTimeline.create, textTimeline.destroy);

    T += timeline.totalDuration;
    T -= 8 * 0.9;

    // Slide 6 - Gallery
    Timeline = require('./timelines/illustrations/GalleryTimeline');
    timeline = Timeline(app, app.stage.smoke, app.stage.pictures, {
        idleDuration: 3.5,
        transitionDuration: 1,
        fadeDuration: 3.5
    });
    flex.add(T, timeline.totalDuration, timeline.create, timeline.destroy);

    textTimeline = DuoText('[data-text-unit="specEffects"]', (timeline.totalDuration - timeline.startDuration) * 1.4 + 0.1);
    flex.add(T + timeline.startDuration - textTimeline.startDuration - 0.1, textTimeline.totalDuration, textTimeline.create, textTimeline.destroy);

    Timeline = require('./timelines/illustrations/GallerySliderTimeline');
    const timeline2 = Timeline('[data-text-unit="specEffects"] .images-slider', (timeline.totalDuration - timeline.startDuration) * 1.4 + 0.1);
    flex.add(T + timeline.startDuration - textTimeline.startDuration - 0.1, timeline2.totalDuration, timeline2.create, timeline2.destroy);
    flex.cuePoints.push(T + timeline.startDuration - textTimeline.startDuration + 1 + timeline2.startDuration);

    T += timeline.totalDuration * 0.9;


    // Slide Set 7 - final "great word"
    Timeline = require('./timelines/illustrations/FinTimeline');
    timeline = Timeline(app, app.stage.finalSeq);
    flex.add(T - timeline.startDuration, timeline.totalDuration + 1.5, timeline.create, timeline.destroy);
    T -= timeline.startDuration;

    // TITLE:
    textTimeline = OpacityText('[data-text-unit="finP1"]', 1, 0.5, 1);
    flex.add(T, textTimeline.totalDuration, textTimeline.create, textTimeline.destroy);

    flex.cuePoints.push(T + 1);

    T += textTimeline.totalDuration - 0.5;


    // TEXT:
    // Mobile
    textTimeline = OpacityText('.sectionsSet--fin', 1, 18 + 1, 1);
    flex.add(T, textTimeline.totalDuration, textTimeline.create, textTimeline.destroy);

    TextTimeline = require('./timelines/texts/TextSliderTimeline');
    textTimeline = TextTimeline('.sectionsSet--fin', 18 + 1);
    flex.add(T + 1, textTimeline.totalDuration, textTimeline.create, textTimeline.destroy);


    // Desktop
    textTimeline = OpacityText('[data-text-unit="finP2"]', 1, 1, 1);
    flex.add(T, textTimeline.totalDuration, textTimeline.create, textTimeline.destroy);

    T += textTimeline.totalDuration - 0.5;

    textTimeline = OpacityText('[data-text-unit="finP3"]', 1, 2, 1);
    flex.add(T, textTimeline.totalDuration, textTimeline.create, textTimeline.destroy);

    T += textTimeline.totalDuration - 0.5;

    textTimeline = OpacityText('[data-text-unit="finP4"]', 1, 2, 1);
    flex.add(T, textTimeline.totalDuration, textTimeline.create, textTimeline.destroy);

    T += textTimeline.startDuration;

    textTimeline = OpacityText('[data-text-unit="finP5"]', 1, 2, 1);
    flex.add(T, textTimeline.totalDuration, textTimeline.create, textTimeline.destroy);

    T += textTimeline.totalDuration - 0.5;

    textTimeline = OpacityText('[data-text-unit="finP6"]', 1, 2, 1);
    flex.add(T, textTimeline.totalDuration, textTimeline.create, textTimeline.destroy);

    T += textTimeline.startDuration;

    textTimeline = OpacityText('[data-text-unit="finP7"]', 1, 2, 1);
    flex.add(T, textTimeline.totalDuration, textTimeline.create, textTimeline.destroy);

    T += textTimeline.totalDuration - 0.5;

    textTimeline = OpacityText('[data-text-unit="finP8"]', 1, 3 + 1, 1);
    flex.add(T, textTimeline.totalDuration, textTimeline.create, textTimeline.destroy);

    T += textTimeline.startDuration;

    textTimeline = OpacityText('[data-text-unit="finP9"]', 1, 2 + 1, 1);
    flex.add(T, textTimeline.totalDuration, textTimeline.create, textTimeline.destroy);

    T += textTimeline.totalDuration - 1;

    TextTimeline = require('./timelines/texts/BgOpacityTimeline');
    textTimeline = TextTimeline('.sectionsSet--conclusion .sectionsSet__bg', 4.5 - 0.4);
    flex.add(T, textTimeline.totalDuration, textTimeline.create, textTimeline.destroy);

    TextTimeline = require('./timelines/texts/ConclusionText');
    textTimeline = TextTimeline('[data-text-unit="conclusion"]', 2);
    flex.add(T, textTimeline.totalDuration, textTimeline.create, textTimeline.destroy);

    T += textTimeline.totalDuration - 0.4;

    TextTimeline = require('./timelines/texts/AuthorsText');
    textTimeline = TextTimeline('[data-text-unit="authors"]', 2.5);
    flex.add(T, textTimeline.totalDuration, textTimeline.create, textTimeline.destroy);


    // console.log(flex.cuePoints)

    return flex;
}

module.exports = initTimeline;


// WEBPACK FOOTER //
// ./js/viscom/vereschagin/ProjectTimelineWithVideo.js